import { theme } from '../../../theme';

import type { AlertSizes } from './types';

export const SpacingMap: Record<AlertSizes, string> = {
  base: theme.sizes.base,
  sm: theme.sizes[3],
  xs: theme.sizes.sm,
};

export const IconSizeMap: Record<AlertSizes, string> = {
  base: theme.sizes.md, // 24px
  sm: theme.sizes[5], // 20px
  xs: theme.sizes[5],
};
